


























import {defineComponent} from "@vue/composition-api"
import { useGetters, useState } from "vuex-composition-helpers";

import CrumbsComponent from "./CrumbsComponent.vue";
import NavigationButtonComponent from "./NavigationButtonComponent.vue";

export default defineComponent({
    name: "Navigation",
    components: {
        CrumbsComponent,
        NavigationButtonComponent
    },
    methods: {
        navigate(index: number, transition: string) {
            this.$store.dispatch('navigate', {index: index, transition: transition})
        }
    },
    props: {
        showCrumbs: {
            type: Boolean,
            default: false
        }
    },
    setup: () => {
        const { config, currentIndex } = useState(['config', 'currentIndex'])
        const { showNavigation } = useGetters(['showNavigation'])

        return {
            config,
            currentIndex,
            showNavigation
        }
    }
})
